import React, { useEffect, useState } from "react";
import { Box, Flex, Image, Text } from "rebass";
import _ from "lodash";
import { format } from "date-fns";
import { Input, Textarea } from "@rebass/forms";
import { Player } from "@lottiefiles/react-lottie-player";

import { apiService } from "../../../apiService";
import { authHeader, checkSessionByName, sessionName } from "../../../session";

import edit_primary from "../../../Assets/edit-primary.svg";
import delete_red from "../../../Assets/delete-red.svg";
import confirm_primary from "../../../Assets/confirm-primary.svg";
import cancel_red from "../../../Assets/cancel-red.svg";
import { useLocation } from "react-router-dom";
import handleUnauthorizedError from "../../../handleUnauthorizedError";

const MedicalLogSection = ({
  navigate,
  register,
  record,
  recordId,
  getRecordInfo,
  setRecordId,
}) => {
  const location = useLocation();

  const [selectedEdit, setSelectedEdit] = useState(-1);
  const [selectedDelete, setSelectedDelete] = useState(-1);

  const [selectedLoading, setSelectedLoading] = useState(-1);
  const [onEditText, setOnEditText] = useState("");

  const [doctorInfo, setDoctorInfo] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setSelectedLoading(-1);
    }, 1500);
  }, [selectedLoading]);

  useEffect(() => {
    const checkSession = async () => {
      const sessionExists = await checkSessionByName(
        sessionName.MENTAL_DOCTOR,
        navigate,
        "/dashboard-login"
      );
      if (sessionExists) {
        getDoctorsInfo();
      }
    };

    checkSession();

    setRecordId(location.state?.recordId);
    document.scrollingElement.scrollTo({ top: 0 });
  }, [location]);

  const getDoctorsInfo = async () => {
    await apiService(`/auth/info`, authHeader())
      .then((response) => {
        const responseData = response.data;
        setDoctorInfo(responseData.doctor);
      })
      .catch((err) => {
        handleUnauthorizedError(err, getDoctorsInfo);
      });
  };

  const formatDate = (pubDate) => {
    const dateStr = new Date(pubDate).toLocaleDateString("th-TH", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    const timeStr = format(new Date(pubDate), ", HH:mm");
    return dateStr + timeStr;
  };

  const editComment = async (log) => {
    setSelectedLoading(log.id);
    let req = {
      log_text: onEditText,
    };
    await apiService
      .post(
        // `/mental/mental_records/${recordId}/medical_log/${log.id}/edit`,
        `/interviews/${recordId}/result-log/${log.id}`,
        req,
        authHeader()
      )
      .then((response) => {
        getRecordInfo(recordId);
        setSelectedEdit(-1);
      })
      .catch((err) => {
        handleUnauthorizedError(err, () => editComment(log));
      });
  };

  const deleteComment = async (log) => {
    setSelectedLoading(log.id);
    await apiService
      .delete(`/interviews/${recordId}/result-log/${log.id}`, authHeader())
      .then((response) => {
        getRecordInfo(recordId);
      })
      .catch((err) => {
        handleUnauthorizedError(err, () => deleteComment(log));
      });
  };

  return (
    <>
      <Text
        mt={36}
        color="#003A66"
        fontWeight={700}
        fontSize="1.5rem"
      >
        บันทึกเพิ่มเติม
      </Text>
      <Flex
        mt={24}
        flex={1}
        flexDirection="column"
        fontFamily="SukhumvitSet-Medium"
        css={{
          background: "#fff",
          boxShadow: "0px 0px 0px 2px rgba(197, 197, 197, 0.25)",
          borderRadius: "7px",
          padding: "1.6rem 2rem",
        }}
      >
        <Textarea
          {...register("extra_info", { required: false })}
          css={{
            fontFamily: "SukhumvitSet-Medium",
            border: "0.5px solid #919191",
            background: "#fff",
            borderRadius: "7px",
            ":focus": {
              outline: "none",
            },
          }}
          placeholder="เพิ่มบันทึก"
        />
        {/* Logs history */}
        <Text
          mt={24}
          fontSize="1.1rem"
          color="#206ED1"
          fontWeight={500}
        >
          ประวัติการบันทึก
        </Text>
        {_.isEmpty(record?.medical_logs) && (
          <Text
            mt={16}
            fontSize="1rem"
            fontWeight={500}
          >
            ไม่มีประวัติ
          </Text>
        )}
        {_.map(
          record?.medical_logs,
          (log, i) =>
            !log?.is_deleted && (
              <Flex
                css={{ borderBottom: "1px solid #7182A6" }}
                key={`log-${i}`}
                id={i}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Flex
                  flexDirection={"column"}
                  width={"80%"}
                >
                  <Flex>
                    <Text
                      pt={3}
                      pb={1}
                      fontSize="1rem"
                      color="#09090A"
                      fontWeight={500}
                    >
                      {`${formatDate(log.pub_date)} - ${log.prefix} ${
                        log.first_name
                      } ${log.last_name} (${log.specialty})`}
                    </Text>
                    {log.is_edited != 0 ? (
                      <Text
                        fontSize={"14px"}
                        color={"#979797"}
                        alignSelf={"flex-end"}
                        pb={1}
                        ml={"4px"}
                      >
                        (Edited)
                      </Text>
                    ) : null}
                  </Flex>
                  {selectedLoading === log.id ? (
                    <Flex justifyContent={"flex-start"}>
                      <Player
                        autoplay
                        loop={true}
                        src={
                          "https://assets5.lottiefiles.com/packages/lf20_w6xlywkv.json"
                        }
                        style={{ height: "42px", width: "100%" }}
                      />
                    </Flex>
                  ) : selectedEdit === i ? (
                    <Input
                      css={{
                        marginBottom: "12px",
                        height: "72px",
                        fontFamily: "SukhumvitSet-Medium",
                        border: "0.5px solid #919191",
                        background: "#fff",
                        borderRadius: "7px",
                        ":focus": {
                          outline: "none",
                        },
                      }}
                      value={onEditText}
                      border="none"
                      onChange={(e) => {
                        setOnEditText(e.target.value);
                      }}
                    ></Input>
                  ) : (
                    <Box>
                      <Text
                        py={2}
                        fontSize="1rem"
                        color="#09090A"
                        fontWeight={500}
                        css={{
                          wordWrap: "break-word",
                        }}
                      >
                        {log.log_text}
                      </Text>
                    </Box>
                  )}
                </Flex>
                {log?.first_name === doctorInfo?.firstname &&
                log?.last_name === doctorInfo?.lastname ? (
                  <Flex
                    mt={2}
                    pb={3}
                    alignSelf={"center"}
                  >
                    {selectedLoading === log.id ? null : selectedEdit === i ? (
                      <Flex>
                        <Flex
                          mr={"20px"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          flexDirection={"column"}
                          onClick={() => {
                            editComment(log);
                          }}
                        >
                          <Image
                            src={confirm_primary}
                            mb={"4px"}
                          ></Image>
                          <Text
                            color={"#1A59C2"}
                            fontSize={14}
                            fontWeight={400}
                          >
                            บันทึก
                          </Text>
                        </Flex>
                        <Flex
                          mr={"12px"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          flexDirection={"column"}
                          onClick={() => {
                            setSelectedEdit(-1);
                          }}
                        >
                          <Image
                            src={cancel_red}
                            mb={"4px"}
                          ></Image>
                          <Text
                            color={"#D22626"}
                            fontWeight={400}
                          >
                            ยกเลิก
                          </Text>
                        </Flex>
                      </Flex>
                    ) : selectedDelete === i ? (
                      <Flex>
                        <Flex
                          mr={"20px"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          flexDirection={"column"}
                          onClick={() => {
                            deleteComment(log);
                          }}
                        >
                          <Image
                            src={confirm_primary}
                            mb={"4px"}
                          ></Image>
                          <Text
                            color={"#1A59C2"}
                            fontSize={14}
                            fontWeight={400}
                          >
                            ยืนยัน
                          </Text>
                        </Flex>
                        <Flex
                          mr={"12px"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          flexDirection={"column"}
                          onClick={() => {
                            setSelectedDelete(-1);
                          }}
                        >
                          <Image
                            src={cancel_red}
                            mb={"4px"}
                          ></Image>
                          <Text
                            color={"#D22626"}
                            fontWeight={400}
                          >
                            ยกเลิก
                          </Text>
                        </Flex>
                      </Flex>
                    ) : (
                      <Flex
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <Flex
                          onClick={() => {
                            setOnEditText(log.log_text);
                            setSelectedEdit(i);
                            setSelectedDelete(-1);
                          }}
                          mr={32}
                          flexDirection={"column"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Image
                            src={edit_primary}
                            width={"20px"}
                            mb={"4px"}
                          ></Image>
                          <Text
                            color={"#1A59C2"}
                            fontSize={14}
                            fontWeight={400}
                          >
                            แก้ไข
                          </Text>
                        </Flex>
                        <Flex
                          flexDirection={"column"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          onClick={() => {
                            setSelectedDelete(i);
                            setSelectedEdit(-1);
                          }}
                          mr={16}
                        >
                          <Image
                            src={delete_red}
                            mb={"4px"}
                          ></Image>
                          <Text
                            fontWeight={500}
                            color={"rgb(254, 39, 74)"}
                          >
                            ลบ
                          </Text>
                        </Flex>
                      </Flex>
                    )}
                  </Flex>
                ) : null}
              </Flex>
            )
        )}
      </Flex>
    </>
  );
};

export default MedicalLogSection;
